export const environment = {
    production: false,
    backend: 'https://admin.voyse-staging.com',
    url: 'https://www.voyse-staging.com',
    api: 'https://api.voyse-staging.com',
    domain: 'https://foo.voyse-staging.com',
    rootDomain: 'voyse-staging.com',
    embedUrl: 'https://development-embed.voyse.io',
    cookieConfig: {
        token: 'voyseDevAdminToken',
        user: 'voyseDevAdminUser'
    },
    gtagId: 'GTM-KZQTDX3'
};
